module.exports = __webpack_public_path__ + "static/media/student-end-season-point-bg.1aa34ac2.png";